import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useTranslations } from "next-intl";

export default function StepperComponent({
  steps = [],
  activeStage = 0,
  ...props
}) {
  const t = useTranslations("Progress");
  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStage} alternativeLabel {...props}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>
              {t(
                label?.toLowerCase()?.replaceAll(" ", "")?.replaceAll("-", "")
              )}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
